import React from 'react';

import {
  SearchComponent,
  ISearchComponent,
} from '../../core/components/SearchComponent';

import lineModules from '../../core/components/lineModules'
import { Container } from './styles';
import { useParams } from 'react-router-dom';


interface ValidationRules {
  type: 'email' | 'required' | 'min' | 'max' | 'length';
  message?: string;
  quantity?: number;
}

interface ValidationSchema {
  name: string;
  type: 'string' | 'number' | 'boolean';
  label: string;
  rules: Array<ValidationRules>;
}
interface IParams {
  projectHash: string;
  eventHash: string;
}


const News: React.FC = () => {
  const endpoint = '/news';
  const title = 'Notícias';

  const { projectHash, eventHash } = useParams<Record<string, any>>();


  const schema: Record<string, any> = {
    _id: { ref: '_id', column: '_id', label: 'ID', show: false },

    title: { ref: 'title', column: 'title', label: 'Título' },
    url: { ref: 'url', column: 'url', label: 'URL' },
    description: { ref: 'description', column: 'description', label: 'Descritivo', show: false },


    createdAt: {
      ref: 'created_at',
      column: 'createdAt',
      label: 'Data de Criação',
      mask: 'date',
    },
  };

  const formSchema = {
    image: {
      model: 'imageSingle',
      type: 'input',
      name: 'image',
      label: 'Foto',
      list: [
        { label: 'Imagem', name: 'url', type: 'input' },

      ],
    },
    start_at: { model: 'datePicker', type: 'text', name: 'start_at', label: 'Data' },


    title: { model: 'input', type: 'text', name: 'title', label: 'Título' },
    short_description: { model: 'richText', type: 'text', name: 'short_description', label: 'Mini descritivo' },
    description: { model: 'richText', type: 'text', name: 'description', label: 'Descritivo' },
    nested_authors: { model: 'input', type: 'text', name: 'nested_authors', label: 'Autores' },

    video: { model: 'input', type: 'text', name: 'video', label: 'Link de Vídeo' },
    images: {
      model: 'imageMulti',
      type: 'input',
      name: 'images',
      label: 'Fotos adicionais',
      list: [
        { label: 'Imagem', name: 'url', type: 'input' },
        { label: 'Título', name: 'title', type: 'input' },

        { label: 'Link', name: 'link_url', type: 'input' },

      ],
    },
    status: {
      model: 'selectSimple',
      name: 'status',
      label: 'Ativo?',
      defaultValue: 'yes',
      options: [
        { label: 'Sim', value: 'yes' },
        { label: 'Não', value: 'no' },
      ]
    },

    categories: {
      model: 'JsonInput',
      project_id: projectHash,
      bodyRender: (data: Record<string, any>) => (
        <nav>
          <strong>
            (
            {data._id})
            {' '}
            {data.title}
          </strong>
        </nav>
      ),
      searchRender: (data: Record<string, any>) => (
        <>
          <strong>
            (
            {data._id})
            {' '}
            {data.title}
          </strong>
        </>
      ),
      storageType: 'data',
      endpoint: `/news-category`,
      name: 'categories',
      label: 'Categorias',
    },
    files: {
      model: 'imageGalleryInput',
      type: 'input',
      name: 'files',
      label: 'Arquivos',
      list: [
        { label: 'Arquivo', name: 'url', type: 'input' },
        { label: 'Título', name: 'title', type: 'input' },


      ],

    },
    buttons: {
      model: 'jsonListMultiple',
      type: 'text',
      name: 'buttons',
      label: 'Botões',
      list: {
        title: { label: 'Título', name: 'title' },
        link: { label: 'Link', name: 'link' },
        class_name: { label: 'Tipo de botão', name: 'class_name' },
      },
    },
    additional_image: {
      model: 'imageSingle',
      type: 'input',
      name: 'additional_image',
      label: 'Imagem adicional',
      list: [
        { label: 'Imagem', name: 'url', type: 'input' },

      ],
    },
    video_gallery: {
      model: 'jsonInputList',
      type: 'text',
      name: 'video_gallery',
      label: 'Galerias de vídeos',
      show: 'title',
      list: [

        { label: 'Título', name: 'title', type: 'input' },


        {
          label: 'videos', name: 'videos', type: 'jsonInputList', list: [

            { label: 'Título', name: 'title', type: 'input' },
            { label: 'Vídeo url', name: 'video', type: 'input' },


          ]
        },


      ]
    },
    /*   theme_data: {
        model: 'jsonList',
        type: 'text',
        name: 'theme_data',
        label: 'Personalização',
        list: [
          { label: 'Fundo', name: 'background' },
          { label: 'Cor da linha', name: 'line_color' },
          { label: 'Cor do título', name: 'title_color' },
          { label: 'Cor do Texto', name: 'text_color' },
        ],
      }, */
  };

  const formSchemaUpdate = {
    url: { model: 'input', type: 'text', name: 'url', label: 'URL' },


    ...formSchema



  };

  const formValidation: Record<string, ValidationSchema> = {

  };

  const config: ISearchComponent = {
    idKey: `${endpoint}-${projectHash}-${eventHash}`,
    title,
    endpoint,
    schema,
    autoStart: true,
    headModules: [
      () =>
        lineModules.create({
          title,
          formSchema,
          validationSchema: formValidation,
          endpoint,

        }),
    ],
    bodyModules: [
      (lineData: Record<string, any>) =>
        lineModules.updateUnique({
          lineData,
          title,
          formSchema: formSchemaUpdate,
          validationSchema: {},
          endpoint,

        }),
      (lineData: Record<string, any>) =>
        lineModules.delete({
          lineData,
          title,
          formSchema,
          validationSchema: formValidation,
          endpoint,

        }),
    ],
  };

  return (
    <Container>
      <SearchComponent {...config} />
    </Container>
  );
};

export default News;
